import { css } from '@emotion/react'
import styled from '@emotion/styled'
import APP_BREAKPOINTS, {
    minRoomWidth,
} from '../../../../../styles/breakpoints'
import { palette } from '../../../../../styles/colors'
import { PAPER_HEIGHTS } from '../../../../../theme'

export const gridRootStyles = css({
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
})

export const gridRootCenter = css({
    justifyContent: 'center',
    alignItems: 'center',
})

export const rootStyles = css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    background: palette.backgroundRaised,
})

export const defaultVerticalStyles = css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    position: 'relative',
    // overflow: 'hidden',
})

export const nonFullscreenStyles = css(defaultVerticalStyles, {
    '& .chat-header': {
        backgroundColor: palette.background,
    },
})
export const verticalRootStyles = css(defaultVerticalStyles, {
    background: palette.background,
})

export const verticalPmStyles = css(defaultVerticalStyles, {
    background: palette.backgroundRaised,
})
export const videoGridStyles = css({
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
})

export const fullWindowStreamContainerStyles = css({
    position: 'relative',
    display: 'flex',
    flexGrow: 0,
    justifyContent: 'flex-start',
    height: '100%',
    width: '100%',
})

export const streamContainerStyles = css(fullWindowStreamContainerStyles, {
    background: palette.videoBackground,
})

export const offlineButtonsStyles = css({
    position: 'absolute',
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-start',
    width: '100%',
    height: '100%',
    padding: 0,
    [minRoomWidth(APP_BREAKPOINTS.md)]: {
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
    },
})

export const spacerStyles = css({
    flex: 1,
    height: '100%',
    width: '100%',
    background: palette.backgroundRaised,
})

export const chatGridStyles = css({
    position: 'relative',
    display: 'block',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    zIndex: PAPER_HEIGHTS.zero,
    '&::-webkit-scrollbar': {
        display: 'none',
    },
})

export const chatPaneStyles = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: palette.backgroundRaised,
    height: '100%',
    // transition: 'opacity 0.4s ease-in-out',
    '& input': {
        width: '100%',
    },
})

export const fullWindowRootStyles = css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
})

export const shareAlbumsStyles = css({
    marginBottom: 10,
})

export const AvatarImage = styled('img')({
    // width: '100%',
    width: 0,
    height: 0,
    opacity: 0,
    zIndex: 1,
    objectFit: 'cover',
    transition: 'opacity ease-in-out 0.4s',
    // animation: ''
    // display: 'none',
})

export const opaqueStyle = css({
    width: '100%',
    height: 'unset',
    opacity: 1,
})

export const AvatarBlurImage = styled('img')({
    position: 'absolute',
    // width: '100%',
    width: 0,
    height: 0,
    objectFit: 'cover',
    opacity: 0,
})
